import { useQuery } from 'react-query';
import { useCallback } from 'react';
import produce from 'immer';
import { toastError, request, queryClient } from '@/utils';
import type { GiftVipHistoryItem } from '../types';

const VIP_HISTORY_REQUEST_URL = '/user/received_vip_list';

type GiftVipHistoryQuery = {
  current_vip?: GiftVipHistoryItem;
  vip_list: GiftVipHistoryItem[];
};
export const useQueryGiftVipHistoryList = (userId: string) => {
  return useQuery(
    [VIP_HISTORY_REQUEST_URL, userId],
    async () => {
      return request.get<GiftVipHistoryQuery>(VIP_HISTORY_REQUEST_URL, {
        id: userId,
      });
    },
    {
      enabled: !!userId,
      cacheTime: 10 * 1000,
      staleTime: 10 * 1000,
      onError(err: any) {
        toastError(err);
      },
    },
  );
};

export const useGiftVipChangeFollowState = () => {
  return useCallback((id: string, isFollowing: boolean) => {
    queryClient.invalidateQueries([VIP_HISTORY_REQUEST_URL]);

    queryClient.setQueriesData<GiftVipHistoryQuery | undefined>(
      [VIP_HISTORY_REQUEST_URL, id],
      pre => {
        if (!pre) {
          return;
        }

        return produce(pre, draft => {
          draft.vip_list.forEach(x => {
            if (x.buyer.id === id) {
              x.buyer.is_following = isFollowing;
            }
          });
        });
      },
    );
  }, []);
};
